<template>
  <div class="body w" style="color: #757575">
    <CBackNav title="选择学校"></CBackNav>
    <div class="offset"></div>

    <!--    搜索框-->
    <div class="search">
      <van-search class='myvansearch' v-model="value"
                  placeholder="请输入学校名称"
                  show-action
                  background=rgba(48,52,61,.9)
                  @search="onSearch"
                  input-align="left" shape="square" label="" left-icon="" right-icon="">
        <template #action>
          <div style="color: whitesmoke; " @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>

<!--    学校列表-->
    <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <div class="minHeight search">
        <div v-for="(item, index) in schools" :key="index">
          <van-cell-group @click="clkItem(item)">
            <div class="schoolName">{{item.school}}</div>
            <div class="schoolAddr">{{getAddr(item)}}</div>
          </van-cell-group>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import NavBar from "../../components/common/navBar/NavBar";
import CBackNav from "../../components/CBackNav";
import mixGetSchool from "../../js/mixins/mixGetSchool";

export default {
  name: "chooseSchool",
  mixins:[mixGetSchool],
  components:{
    NavBar,
    CBackNav,
  },
  data(){
    return {
      value: '',
      lastValue: '',
    }
  },
  created() {
    console.log("choose school create")
  },
  mounted() {
    //this.searchSchoolsName()
  },
  destroyed() {
    console.log("choose school destroyed")
  },
  methods:{
    clkItem(item){
      console.log(item.id)
      this.$bus.emit("schoolChange",{'item': item})
      this.$router.back()
    },
    getAddr(info){
      return info.province + info.city + info.district + info.address
    },
    onBack(){
      console.log("back ************************")
    },
    //=========================参赛编号或姓名--搜索
    onSearch(val) {
      console.log(this.value)
      if(this.value!=this.lastValue){
        this.lastValue=this.value
        // this.getCansaiVideo()
        this.refresh(this.value)
      }
    },
  }
}
</script>

<style scoped>
.schoolName{
  color: black;
  font-weight: bolder;
  font-size: 32px;
  padding-top: 25px;
  padding-left: 12px;
}
.schoolAddr{
  padding-top: 15px;
  padding-left: 12px;
  padding-bottom: 30px;
  color: #b7b7b7;
  font-size: 25px;
}
.body{
  background-color: #f6f7fb;
  width: 100%;
  min-height: 100vh;
}
.offset{
  width: 100%;
  height: 40px;
}
.search{
  width: 910px;
  margin: auto;
  margin-top: 50px;
}
.myvansearch >>> .van-search__content{
  /*background-color: #210c01;*/
  background-color: white;
}
.myvansearch >>> .van-search__action:active{
  background-color: #706f6f;
  border-radius: 5px;
}
.myvansearch >>> .van-field__control{
  /*color: #ffe9af;*/
  /*color: whitesmoke;*/
  color: #3c3d41;
  font-size: 40px;
}
.myvansearch >>> input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color: #b0aeae;
}
.myvansearch >>> :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color:    #b0aeae;
}
.myvansearch >>> ::-moz-placeholder { /* Mozilla Firefox 19+ */
  color:    #b0aeae;
}
.myvansearch >>> input:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color:   #b0aeae;
}
.myvansearch >>> input::-ms-input-placeholder { /* Microsoft Edge */
  color:    #b0aeae;
}
.search >>> .van-search{
  padding: 5px 5px;
  border-radius: 6px;
  background-color: #646566;
  color: #ee0a24;
}
</style>